import script from "./SubscriptionPlanOption.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPlanOption.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPlanOption.vue?vue&type=style&index=0&id=ad9a5ba4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9a5ba4"]])

export default __exports__